export type FaqCategory = "studio" | "engagement" | "pricing" | "process" | "trust";

export interface FaqItem {
  id: string;
  category: FaqCategory;
  questionKey: string;
  answerKey: string;
}

export const FAQS: FaqItem[] = [
  // studio
  {
    id: "ship-fast",
    category: "studio",
    questionKey: "faq.items.ship-fast.q",
    answerKey: "faq.items.ship-fast.a",
  },
  {
    id: "built-by-ai",
    category: "studio",
    questionKey: "faq.items.built-by-ai.q",
    answerKey: "faq.items.built-by-ai.a",
  },
  {
    id: "tech-stack",
    category: "studio",
    questionKey: "faq.items.tech-stack.q",
    answerKey: "faq.items.tech-stack.a",
  },
  // engagement
  {
    id: "after-scoping",
    category: "engagement",
    questionKey: "faq.items.after-scoping.q",
    answerKey: "faq.items.after-scoping.a",
  },
  {
    id: "outside-bogota",
    category: "engagement",
    questionKey: "faq.items.outside-bogota.q",
    answerKey: "faq.items.outside-bogota.a",
  },
  // pricing
  {
    id: "cost-timeline",
    category: "pricing",
    questionKey: "faq.items.cost-timeline.q",
    answerKey: "faq.items.cost-timeline.a",
  },
  {
    id: "what-is-automation-audit",
    category: "pricing",
    questionKey: "faq.items.what-is-automation-audit.q",
    answerKey: "faq.items.what-is-automation-audit.a",
  },
  // process
  {
    id: "scope-creep",
    category: "process",
    questionKey: "faq.items.scope-creep.q",
    answerKey: "faq.items.scope-creep.a",
  },
  {
    id: "communication",
    category: "process",
    questionKey: "faq.items.communication.q",
    answerKey: "faq.items.communication.a",
  },
  // trust
  {
    id: "ip-ownership",
    category: "trust",
    questionKey: "faq.items.ip-ownership.q",
    answerKey: "faq.items.ip-ownership.a",
  },
  {
    id: "code-quality",
    category: "trust",
    questionKey: "faq.items.code-quality.q",
    answerKey: "faq.items.code-quality.a",
  },
  {
    id: "data-handling",
    category: "trust",
    questionKey: "faq.items.data-handling.q",
    answerKey: "faq.items.data-handling.a",
  },
];

export const FAQ_CATEGORY_ORDER: FaqCategory[] = [
  "studio",
  "engagement",
  "pricing",
  "process",
  "trust",
];
